import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
//state vuex数据存储库
const state = {
  index:1,
  cms: {
    settings: {},
    portfolio: [],
    team: [],
    honors: [],
    offices: []
  },
  cmsReady: false
}
//getters vuex的计算属性,监听并抛出state里的值
const getters = {
  gindex(state) {  //方法名随意,主要是来承载变化的showFooter的值
   return state.index
  }
}
// mutations 改变初始值得方法
const mutations = {
  mindex(state,param) {
    state.index += param
  },
  setCms(state, content) {
    state.cms = Object.assign({ settings: {}, portfolio: [], team: [], honors: [], offices: [] }, content)
    state.cmsReady = true
  }
}
// actions Action 类似于 mutation，不同在于：
// Action 提交的是 mutation，而不是直接变更状态。
// Action 可以包含任意异步操作。
const actions = {
 amindex(context,param) {
   context.commit('mindex', param)
 }
}
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js